import React from "react";
import PayrollRomms from "../../payroll/PayrollRomms";

interface OtherFinancialAssetsRommsProps {
  onBack: () => void;
}

export default function OtherFinancialAssetsRomms({ onBack }: OtherFinancialAssetsRommsProps) {
  return <PayrollRomms onBack={onBack} onComplete={() => {}} workspace="Other Financial Assets" />;
}

